exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".file-uploads-transition .card[data-v-05ae8983]{transition:transform .15s}.file-limit-reached[data-v-05ae8983]{padding:0 5px;color:#ccc}.upload-button[data-v-05ae8983]{margin-top:10px}", ""]);

// exports
